'use strict';

var toPosInt   = require('es5-ext/number/to-pos-integer')
  , maxTimeout = require('./max-timeout');

module.exports = function (value) {
	value = toPosInt(value);
	if (value > maxTimeout) throw new TypeError(value + " exceeds maximum possible timeout");
	return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/timers-ext/valid-timeout.js
// module id = 1412
// module chunks = 0